import { action, observable } from 'mobx';
import * as LiveBroadcastServices from '../services/LiveBroadcastServices';

class LiveBroadcastStore {
  @observable streamId = null;
  @observable isSpotlight = false;
  @observable spotlightedByAnchorNickname = null;
  @observable subscribedToOneOfTheAnchors = false;

  @action setIsSpotlight = value => {
    this.isSpotlight = value;
  }

  @action setSpotlightedByAnchorNickname = value => {
    this.spotlightedByAnchorNickname = value;
  }

  @action setSubscribedToOneOfTheAnchors = value => {
    this.subscribedToOneOfTheAnchors = value;
  }

  @action setStreamId = streamId => {
    this.streamId = streamId;
  }

  @action updateSfwStreamFlag = nsfw => {
    const payload = {
      id: this.streamId,
      sfw: !nsfw
    }

    LiveBroadcastServices.updateSfwStreamFlag(payload);
  }
}

export default new LiveBroadcastStore();